const RESOURCES_PT = {
  AIPR: "AIPR",
  BTP_PRO_CARD: "Cartão Profissional BTP",
  CACES: "CACES",
  CE_CERTIFICATE: "Certificado CE",
  CE_CERTIFICATION: "Certificação CE",
  DELIVERY: "Entrega",
  DEPARTURE_NOTE: "Nota de saída",
  DRIVING_AUTHORIZATION: "Autorização de Condução",
  DUE: "Vencido",
  documentsStatus: "Estado dos documentos",
  EMAILS: "Email",
  HOUR_SHEET: "Folhas de horas",
  ICON: "Ícone",
  ID: "ID",
  IDENTITY: "Identidade",
  INSURANCE: "Seguro",
  INVOICE: "Fatura",
  KBIS: "Kbis",
  LIFTING_PLAN: "Plano de Elevação",
  LIFTING_SHEET: "Folha de Elevação",
  LOGO: "Logótipo",
  MACHINE_SPECIFICATIONS: "Especificações da Máquina",
  MAINTENANCE_LOG: "Registo de Manutenção",
  MAINTENANCE_LOG_EXCERPT: "Excerto do Registo de Manutenção",
  MEDICAL_CERTIFICATE: "Atestado Médico",
  OPERATOR_DOCUMENT: "Documento do Operador",
  OTHER: "Outro",
  PGI: "PGI",
  PHOTO: "Foto",
  PIC: "PIC",
  PURCHASE_ORDER: "Ordem de Compra",
  QUOTATION: "Orçamento",
  RETURN_NOTE: "Nota de devolução",
  RIB: "RIB",
  SIGNED_RENTAL_REQUEST: "Pedido de Aluguer Assinado",
  SPECIFIC_TRAINING: "Formação Específica",
  TECHNICAL_SHEET: "Ficha Técnica",
  USED_MACHINE_CERTIFICATE: "Certificado de Máquina Usada",
  USER_MANUAL: "Manual do Utilizador",
  VGP: "VGP",
  WORK_ORDER: "Ordem de trabalho",
} as const;

export default RESOURCES_PT;
